import { PERMISSION_KEYS } from 'constants-permissions';
import {
  hasPermissionOnExactChannel,
  type ChannelRole,
} from './hasPermissionOnExactChannel';
import type { ActorUser } from './toActor';

export type CompanyHolderCandidate = Pick<ActorUser, 'isSuperUser'> & {
  roles: ChannelRole[];
};

export const isCompanyServiceRequestHolder = (
  user: CompanyHolderCandidate | null | undefined,
  companyId: string | null | undefined
): boolean =>
  Boolean(user?.isSuperUser) ||
  hasPermissionOnExactChannel(
    user?.roles,
    PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_VIEW_EDIT_COMPANY,
    companyId
  );
